module.exports = {
	"INLINE": "Testito",
	"nav_home": "Inicio",
	"nav_menu": "Ementa",
	"nav_about": "Restaurante",
	"nav_wines": "Vinos",
	"nav_suggestions": "Sugerencias",
	"nav_events": "Eventos",
	"nav-feedback": "Su opinión",
	"nav-pickly": "Acerca de Pickly",
	"follow_text": "Síguenos",
	"desktop_languages": "Idiomas",
	"intro_default_option": "Filtrar el menú por:",
	"suggested_extras": "Acompañamientos sugeridos",
	"suggested_wines": "Vinos sugeridos",
	"cta_title": "Vea nuestra selección de",
	"cta_btn": "Ver",
	"related_products": "Productos Similares",
	"error_home_link": "Volver al principio",
	"error_home_title1": "Hmm ... que bonito",
	"error_home_title2": "No se pudo encontrar la página que busca.",
	"error_home_text": "Intente reescribir la dirección o inténtelo de nuevo más tarde.",
	"detail_title": "en detalle",
	"list_event_title": "Eventos",
	"event_link": "Página oficial",
	"other_events": "Otros eventos",
	"filters": "Filtros",
	"filter-group-region-type": "Tipo de Vino y Región",
	"region_default_option": "Elija una región",
	"filter-group-type": "Tipo",
	"type_default_option": "Elija un tipo",
	"filter-group-flavour": "Sabor",
	"filter-group-characteristics": "Características del vino",
	"sweetness_default_option": "Acidez",
	"filter-group-body": "Cuerpo",
	"body_default_option": "Elija el cuerpo",
	"filter-group-ingredientes": "Ingredientes Principales",
	"filter-group-diets": "Intolerancias",
	"filter-results": "{results} resultados",
	"filter-clear-button": "Borrar filtros",
	"filter-apply-button": "Aplicar",
	"related_dishes": "Platos sugeridos",
	"empty-title": "Sin resultados",
	"empty-text": "Por el momento no tenemos resultados para presentarle, por favor inténtelo de nuevo con nuevos parámetros.",
	"feedback-title": "Ayúdanos a mejorar",
	"feedback-intro": "Déjanos tus críticas y opiniones para poder mejorar Pickly para ti.",
	"feedback-improve": "Pickly ha mejorado su experiencia en el restaurante?",
	"feedback-error": "Por favor elija una opción",
	"feedback-harder": "Complicó",
	"feedback-no-help": "No ayudó",
	"feedback-indiferent": "Indiferente",
	"feedback-assistance": "Ayudó",
	"feedback-assistance-a-lot": "Ayudó Bastante",
	"feedback-recommend": "¿Recomendar a otros restaurantes a usar Pickly?",
	"feedback-no-recommend": "No recomiendo",
	"feedback-recommend-neutral": "Indiferente",
	"feedback-recommend-yes": "Recomiendo",
	"feedback-msg": "Déjanos tu opinión sobre tu experiencia y cómo crees que podríamos mejorar la aplicación (opcional)",
	"feedback-submit": "Enviar",
	"feedback-thanks-title": "Gracias",
	"feedback-thanks-text": "Gracias por ayudarnos a mejorar! Puede volver al principio a través del botón de abajo.",
	"restaurant-feedback-title": "Su opinión es importante.",
	"restaurant-feedback-subtitle": "Ayúdanos a mejorar.",
	"restaurant-feedback-intro": "Cuéntanos cómo fue tu experiencia en nuestro restaurante, evaluando el servicio, la comida y el ambiente, a través de un breve cuestionario.",
	"restaurant-feedback-intro-btn": "Dar Feedback",
	"food-feedback-title": "Evaluación de la COMIDA",
	"food-feedback-intro": "Dé su opinión y ayúdanos a mejorar.",
	"choice-question": "El menú tenía una buena selección de platos",
	"presentation-question": "Los platos tenían una buena presentación",
	"tasty-question": "La comida era sabrosa y bien confeccionada",
	"service-feedback-title": "Evaluación del servicio",
	"speed-question": "Fueron rápidos a tratar nuestra petición",
	"waiters-question": "Los empleados fueron simpáticos y atenciosos",
	"overall-question": "En general, el servicio fue bueno",
	"global-feedback-title": "Evaluación GLOBAL",
	"deco-question": "El restaurante tenía un buen ambiente y decoración",
	"price-question": "La relación precio / calidad fue buena",
	"recommend-question": "Recomendaría el restaurante a un amigo",
	"comments-question": "Comentarios y sugerencias",
	"recommend_title": "¿Recomendar este plato?",
	"recommend_title_drink": "¿Recomendar esta bebida?",
	"recommend-total": "{total} los clientes recomiendan este plato.",
	"recommend-total_drink": "{total} los clientes recomiendan esta bebida.",
	"type": "tipo",
	"body": "cuerpo",
	"region": "región",
	"accidity": "acidez",
	"mypick-text": "Con myPick selecciona los platos, las bebidas y los postres preferidos para esta comida, luego es sólo pedir al camarero.",
	"cookie-notice": "Al utilizar este sitio estará permitiendo el uso de cookies para análisis y estadística.",
	"cookie-link": "Más información",
	"terms-title": "Términos y condiciones",
	"cookies-title": "Política de cookies",
	"drinks-link-all": "Ver todos",
	"toggle_list": "Lista",
	"toggle_cards": "Cartas",
	"price_under_request": "Precio bajo consulta"
};


/*****************
 ** WEBPACK FOOTER
 ** ./locales/es-es.json
 ** module id = 275
 ** module chunks = 0
 **/